import React from 'react';

const Faq = () => {

    return (
        <div>
            <h1 className="text-center">FAQ</h1>
        </div>
    )
}

export default Faq;